import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import ToggleListItemEditable from './ToggleListItemEditable';
import ToggleListItemReadOnly from './ToggleListItemReadOnly';

const ToggleListItemNodeView: React.FC = () => {
  const { view } = useReactNodeView();

  if (!view?.editable) {
    return <ToggleListItemReadOnly />;
  }

  return <ToggleListItemEditable />;
};

export default ToggleListItemNodeView;
